import { CategoriesResponse } from './interfaces';
import { apiService } from '../../lib/services/api-service';

export const fetchCategories = async () => {
  return await apiService.get<CategoriesResponse>('/categories');
};
